import PropTypes from 'prop-types';
import React from 'react';
import { Radio } from 'rebass';
import config from 'frontend/config';

const RaidbotsRadio = props => {
  const { disabled, checked } = props;
  let backgroundColor;
  if (checked) {
    backgroundColor = config.colors.black;
  }
  if (disabled) {
    backgroundColor = config.colors.red;
  }
  return (
    <Radio
      {...props}
      backgroundColor={backgroundColor}
    />
  );
};

RaidbotsRadio.propTypes = {
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
};

RaidbotsRadio.defaultProps = {
  disabled: false,
  checked: false,
};

export default RaidbotsRadio;
